import { useContext, useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { ProfileContext } from 'src/consumer/context/ProfileContext';
import { SetupContext } from 'src/consumer/context/SetupContext';
import { getFocusAreaOptions, getFocusOptions, getProfileDetails, getProfilePayloadForGoals, handleOptionClick } from 'src/consumer/helpers/profilePageHelper';
import { postData } from 'src/consumer/services/profileService';
import { renderDrawerItems } from '../SelectorDrawer';
import { EditGoalsButton, GoalItemsContainer, GoalsContainer, GoalsHeader, GoalsHeading, SaveGoalsButton, StyledSwitch, StyledSwitchOption } from './GoalsStyle';
import { DisplayFlex } from './ProfileLeftPannelStyle';


const Goals = (props) => {
    const { setupData } = useContext(SetupContext);
    const { profileData, setProfileData } = useContext(ProfileContext);
    const focusAreaOptions = getFocusAreaOptions(setupData);
    const { mindAndBodyItems, beingAndBeyondItems } = getFocusOptions(setupData);
    const { focusAreas, bodyTopics, mindTopics, soulTopics } = getProfileDetails(profileData);
    const [selectedFocusAreas, setSelectedFocusAreas] = useState(focusAreas);
    const [selectedBodyTopics, setSelectedBodyTopics] = useState(bodyTopics);
    const [selectedMindTopics, setSelectedMindTopics] = useState(mindTopics);
    const [selectedSoulTopics, setSelectedSoulTopics] = useState(soulTopics);
    const isFocusAreaEnabled = focusAreaOptions && focusAreaOptions?.length;
    const [drawerItems, setDrawerItems] = useState(isFocusAreaEnabled ? focusAreaOptions : mindAndBodyItems);
    const [selectedFocusOption, setSelectedFocusOption] = useState('mindAndBody');
    const [isDisabled, setIsDisabled] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);

    const { localizedContent } = props;

    const handleOnSave = async () => {
        setButtonLoading(true);
        const newProfilePayload = getProfilePayloadForGoals(profileData, selectedFocusAreas, selectedBodyTopics, selectedMindTopics, selectedSoulTopics, isFocusAreaEnabled);
        await postData('/api/secure/user/update', newProfilePayload);
        setProfileData(newProfilePayload);
        setButtonLoading(false);
        setIsDisabled(true);
        window.location.reload();
    }

    const handleOnClick = (clickedItem) => {
        if (isDisabled) {
            return null;
        } else {
            let tempSelectedItems;
            switch (clickedItem?.type) {
                case 'soul':
                    tempSelectedItems = [...selectedSoulTopics];
                    tempSelectedItems = handleOptionClick(tempSelectedItems, clickedItem);
                    setSelectedSoulTopics(tempSelectedItems);
                    break;
                case 'mind':
                    tempSelectedItems = [...selectedMindTopics];
                    tempSelectedItems = handleOptionClick(tempSelectedItems, clickedItem);
                    setSelectedMindTopics(tempSelectedItems);
                    break;
                case 'body':
                    tempSelectedItems = [...selectedBodyTopics];
                    tempSelectedItems = handleOptionClick(tempSelectedItems, clickedItem);
                    setSelectedBodyTopics(tempSelectedItems);
                    break;
                default:
                    tempSelectedItems = [...selectedFocusAreas];
                    tempSelectedItems = handleOptionClick(tempSelectedItems, clickedItem);
                    setSelectedFocusAreas(tempSelectedItems);
            }
        }
    }


    const handleSelectFocus = (selectedOption, drawerItems, selectedItems) => {
        setSelectedFocusOption(selectedOption);
        setDrawerItems(drawerItems);
    }


    return (
        <GoalsContainer>

            <GoalsHeader>
                <GoalsHeading>Goals</GoalsHeading>
                {isDisabled &&
                    <EditGoalsButton
                        onClick={() => setIsDisabled(false)}
                    >
                        Edit Goals
                    </EditGoalsButton>}
                {!isDisabled &&
                    <DisplayFlex>
                        {/* <CancelButtonGoals>Cancel</CancelButtonGoals> */}
                        <SaveGoalsButton
                            disabled={isDisabled || buttonLoading}
                            onClick={handleOnSave}
                        >
                            {!buttonLoading ? (localizedContent?.save || 'Save Goals') : <Spinner animation="border" variant="light" size="md" />}
                        </SaveGoalsButton>
                    </DisplayFlex>
                }
            </GoalsHeader>

            {
                !isFocusAreaEnabled && <StyledSwitch>
                    <StyledSwitchOption isSelected={selectedFocusOption === 'mindAndBody'} onClick={() => handleSelectFocus('mindAndBody', mindAndBodyItems, [...bodyTopics, ...mindTopics])}>
                        Mind & Body
                    </StyledSwitchOption>
                    <StyledSwitchOption isSelected={selectedFocusOption === 'beingAndBeyond'} onClick={() => handleSelectFocus('beingAndBeyond', beingAndBeyondItems, soulTopics)}>
                        Being & Beyond
                    </StyledSwitchOption>
                </StyledSwitch>
            }

            <GoalItemsContainer>
                {
                    renderDrawerItems(drawerItems, isFocusAreaEnabled ? selectedFocusAreas :
                        selectedFocusOption === 'beingAndBeyond' ? selectedSoulTopics : [...selectedBodyTopics, ...selectedMindTopics], handleOnClick)
                }
            </GoalItemsContainer>

        </GoalsContainer >
    );
}

export default Goals;